export default __webpack_public_path__ + "static/media/telegram-icon.f35b46d1.svg";